<template>
    <div :class="['wrapBg',bgImg]">
        <div class="wrapTitle text-center" :style="{color:color}">{{title}}</div>
        <div class="wrapBox">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WrapBg",
        props:['title','bgImg','color'],
        data(){
            return{

            }
        },
    }
</script>

<style lang="less" scoped>
    .wrapBg{
        .wrapTitle{
            height:96px;
            line-height: 96px;
            font-size:24px;
            color:#fff;
        }
        .wrapBox{
            width:980px;
            min-height:390px;
            margin:0 auto;
            padding: 15px;
            box-sizing: border-box;
            background-color: #fff;
        }
    }
    .chargeBg{
        background:url('../assets/chargeBg.png') no-repeat center;
    }
    .billBg{
        background:url('../assets/billBg.png') no-repeat center;
    }
    .myBg{
        background:url('../assets/myBg.png') no-repeat center;
    }
</style>